/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Identifies the different pupille options
 */
enum Pupille {
  Non = 'non',
  Nation = 'nation',
  Etat = 'etat',
}

export default Pupille;
